/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  AnswerActionRequest,
  AnswerActionResponse,
  CompleteActionPlanResponse,
  InProgressActionPlanDto
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getActionPlans = () => {
/**
 * Records a vendor's completion status for a specific action within an action plan.
 * The vendor indicates whether the corrective action has been completed (true) or not (false).
 * This endpoint updates the action plan's progress and completion percentage accordingly.
 * @summary Validate (answer) an action inside an action plan
 */
const validateAction = (
    actionPlanId: string,
    answerActionRequest: AnswerActionRequest,
 ) => {
      return customInstance<AnswerActionResponse>(
      {url: `/api/v1/action_plans/${actionPlanId}/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: answerActionRequest
    },
      );
    }
  /**
 * Marks an action plan as completed by the authenticated user. This endpoint should be
 * called when all required actions have been validated. The action plan transitions from
 * IN_PROGRESS to COMPLETED status. Returns 403 Forbidden if the user is not authorized
 * to complete this action plan.
 * @summary Complete an action plan
 */
const completeActionPlan = (
    actionPlanId: string,
 ) => {
      return customInstance<CompleteActionPlanResponse>(
      {url: `/api/v1/action_plans/${actionPlanId}/complete`, method: 'POST'
    },
      );
    }
  /**
 * Returns in progress action plans visible for the authenticated user, for a given store/team.
 * @summary Get in progress action plans for a store/team
 */
const getInProgressActionPlans = (
    storeId: number,
    teamId: number,
 ) => {
      return customInstance<InProgressActionPlanDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/action_plans/in_progress`, method: 'GET'
    },
      );
    }
  return {validateAction,completeActionPlan,getInProgressActionPlans}};
export type ValidateActionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActionPlans>['validateAction']>>>
export type CompleteActionPlanResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActionPlans>['completeActionPlan']>>>
export type GetInProgressActionPlansResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActionPlans>['getInProgressActionPlans']>>>
